import React from "react";
import Dialog, {
  IProps as DialogProps,
} from "../../components/organisms/Dialog";
import { useMapDialogContext } from "../../context/ContextProvider";

export const initialDialogProps: DialogProps = {
  open: false,
  children: undefined,
};

const DialogMapContainer = () => {
  const { mapDialogProps }: { mapDialogProps: DialogProps } =
    useMapDialogContext();
  return <Dialog container="map" {...mapDialogProps} />;
};

export default DialogMapContainer;
